import React  from "react";
import { connect } from "react-redux";
import BrowseTrainingTable from "./components/BrowseTrainingTable";



const BrowseTrainings = () => {
	return (

    <div>
      <div className="w-full mt-5">
          <BrowseTrainingTable />
      </div>
    </div>
      
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(BrowseTrainings);